import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import Screen from '../components/ui/Screen'
import texts from '../texts'
import { setAuthMarker } from '../lib/api'

const PENDING_INVITE_KEY = 'wb-pending-invite'

interface AuthCallbackProps {
  setAuth: (value: boolean) => void
}

function AuthCallback({ setAuth }: AuthCallbackProps) {
  const navigate = useNavigate()

  useEffect(() => {
    const params = new URLSearchParams(window.location.hash.replace(/^#/, ''))
    const ok = params.has('ok')
    const userId = params.get('userId')
    const name = params.get('name')

    if (ok && userId && name) {
      setAuthMarker(Number(userId), name)
      setAuth(true)
      const pendingInvite = localStorage.getItem(PENDING_INVITE_KEY)
      if (pendingInvite) {
        localStorage.removeItem(PENDING_INVITE_KEY)
        navigate(`/j/${pendingInvite}`, { replace: true })
      } else {
        navigate('/', { replace: true })
      }
    } else {
      navigate('/login', { replace: true })
    }
  }, [navigate, setAuth])

  return (
    <Screen bare center>
      <p className="text-center text-text-2">{texts.authCallback.loggingIn}</p>
    </Screen>
  )
}

export default AuthCallback
